import { configureStore } from '@reduxjs/toolkit';
import authReducer from './auth/authSlice';
import globalDataReducer from './globalData/globalDataSlice';
import userDataReducer from './globalData/userSlice';
import usersSearchReducer from './globalData/usersSearchSlice';
import invoiceSearchReducer from './globalData/invoiceSearchSlice';
import emailTrackingReducer from './globalData/emailTrackingSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    globalData: globalDataReducer,
    createdInvoiceUserData: userDataReducer,
    usersSearch: usersSearchReducer,
    invoiceSearch: invoiceSearchReducer,
    emailTracking: emailTrackingReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['auth/setNotifications'],
        ignoredActionsPaths: ['payload.createdAt.date', 'meta.arg', 'payload.timestamp'],
         ignoredPaths: ['auth.notifications'],
      },
    }),
});

export default store;
